import { useAuthState } from 'packages/core'

const ControlsAccess = () => {
    const [
        {
            access: { controls },
        },
    ] = useAuthState()

    return controls
}
export default ControlsAccess
